// extracted by mini-css-extract-plugin
export default {"unmergeSchoolsStep1Container__btnGroup":"UnmergeSchoolsStep1_unmergeSchoolsStep1Container__btnGroup__SCOlb"};